import { render, staticRenderFns } from "./type236.vue?vue&type=template&id=3e35df3e&"
import script from "./type236.vue?vue&type=script&lang=js&"
export * from "./type236.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports